import React, { useRef } from 'react';
import { connect } from 'react-redux';

import { toggleModal } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper } from 'apps/auth/components/common/Panel/styles';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { Text } from 'apps/auth/components/common/Text/Text';
import ValidationPopup from 'apps/auth/components/ga/activity/popup/ValidationPopup';
import CashPayoutSecretCodeModal from 'apps/auth/components/history/send/cheque/modals/CashPayoutSecretCodeModal';
import InteracSecretCodeModal from 'apps/auth/components/history/send/cheque/modals/InteracSecretCodeModal';
import { STATUS_OK } from 'apps/auth/constants/Constants';
import { CASH_DELIVERY, CASH_PICKUP, INTERAC } from 'apps/auth/constants/GaConstants';
import { apiFetchData } from 'apps/auth/helpers/api';

const getRepeatURL = (pocketId, payId) => `/auth/ga/pocket/${pocketId}/send/gt/repeat/${payId}`;

const GACheckButtons = (props) => {
    const popupRef = useRef(null);
    const item = props.item;
    const mobileInfo = item.mobileInfo;
    const { stsId } = props.options;

    const clickRepeat = async (e) => {
        e.preventDefault();
        const repeatURL = getRepeatURL(props.pocketId, mobileInfo.gtPayId);
        const json = await apiFetchData(repeatURL);
        if (json?.extra?.invalidBalance) {
            popupRef.current?.open(<ValidationPopup data={json} pocketId={props.pocketId} popupRef={popupRef} />);
        } else {
            window.location.href = repeatURL;
        }
    };

    const getActionButton = () => {
        if (mobileInfo.extraFields.transactionCode && mobileInfo.icon === INTERAC && stsId > 10 && stsId < STATUS_OK) {
            return (
                <Button
                    variant="row"
                    onClick={(e) => {
                        e.preventDefault();
                        props.toggleModal(true, <InteracSecretCodeModal cheque={item} />);
                    }}
                    caption={props.interacNotifyButton}
                    negativeMargin
                />
            );
        }
        if (mobileInfo.extraFields.transactionCode && mobileInfo.icon === CASH_PICKUP && stsId > 10 && stsId < STATUS_OK) {
            return (
                <Button
                    variant="row"
                    onClick={(e) => {
                        e.preventDefault();
                        props.toggleModal(true, <CashPayoutSecretCodeModal cheque={item} />);
                    }}
                    caption={props.interacNotifyButton}
                    negativeMargin
                />
            );
        }
        if (mobileInfo.icon === CASH_DELIVERY && stsId > 10 && stsId < STATUS_OK) {
            return (
                <Button
                    variant="row"
                    onClick={(e) => {
                        e.preventDefault();
                        props.toggleModal(true, <CashPayoutSecretCodeModal cheque={item} />);
                    }}
                    caption={props.interacNotifyButton}
                    negativeMargin
                />
            );
        }
        return (
            <Panel isHoverable type="button" onClick={clickRepeat} negativeMargin>
                <DiskBadgeWrapper>
                    <DiskBadge variant="primary" iconName="retry" />
                </DiskBadgeWrapper>
                <Text color="primary">{props.repeatButton}</Text>
            </Panel>
        );
    };

    return (
        <>
            <Separator />
            {getActionButton()}
            <PopupNew ref={popupRef} />
        </>
    );
};

const mapStateToProps = (state) => ({
    repeatButton: state.messages.pageMessages.repeatButton,
    interacNotifyButton: state.messages.pageMessages.interacNotifyButton,
});

export default connect(mapStateToProps, { toggleModal })(GACheckButtons);
